import { gql } from '@apollo/client';

export const LOAD_MISSION = gql`
  query loadMissions($userId: String!) {
    extracurricular: loadMissions (userId: $userId, category: "ACTIVITIES", subcategory: "Extracurricular Activities") {
      id
      title
      description
      extracurricular {
        id
        subType
        activityType
        organizationName
        position
        hoursPerWeek
        weeksPerYear
        description
      }
    }
    research: loadMissions (userId: $userId, category: "ACTIVITIES", subcategory: "Academic Research & Publications") {
      id
      title
      description
      research {
        id
        provider
        field
        subField
        criProgram
      }
    }
    program: loadMissions (userId: $userId, category: "ACTIVITIES", subcategory: "University Courses & Summer Programs") {
      id
      title
      description
      program {
        id
        type
        resourceCategoryName
      }
    }
    experience: loadMissions (userId: $userId, category: "ACTIVITIES", subcategory: "Internship & Work Experience") {
      id
      title
      description
      experience {
        id
        industry
        organizationName
        programProvider
        position
        applicationDeadline
        impactFactor
      }
    }
    honor: loadMissions (userId: $userId, category: "COMPETITIONS_HONORS", subcategory: "Competitions & Honors") {
      id
      title
      description
      honor {
        id
        userId
        missionId
        category
        award
        awardLevel
        schoolYear
        levelOfRecognition
        resourceId
        divisionId
      }
    }
  }
`;

export const USER_INFO_FRAGMENT = gql`
  fragment userInfo on userType {
    id: userId
    firstName
    lastName
    email
    country
    name: fullName
    description: bio
    profilePhoto: profileImageUrl
    preferredName
    studentInfo {
      schoolYearLevel
      yearOfApplication
      major
      majors
      hookStatement
    }
    roles {
      roleId
      isPrimary
    }
  }
`;

export const QUERY_USER_INFO = gql`
  query userById($userId: String!) {
    user: userWithoutPermissionCheck(userId: $userId) {
      ...userInfo
    }
  }
  ${USER_INFO_FRAGMENT}
`;

export const GET_USERS_BY_IDS = gql`
  ${USER_INFO_FRAGMENT}
  query fetchUsersByIds($userIds: [String]!) {
    usersBasicInfo(userIds: $userIds) {
      ...userInfo
    }
  }
`;
